import React from 'react';

import { ErrorViewModel } from '@api/index';
import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';

import { ErrorMessage, ErrorMessageWrapper } from './style';

interface Props {
  errors: ErrorViewModel[];
}

const ErrorMessages = ({ errors }: Props) => (
  <>
    {errors?.map((error) => (
      <ErrorMessageWrapper key={error.title}>
        <CustomIcon icon={InfoIcon} paletteColor='coral' fontSize={15} />

        <ErrorMessage>{error.detail}</ErrorMessage>
      </ErrorMessageWrapper>
    ))}
  </>
);

export default ErrorMessages;
